import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "cash-history bg-[#23242A] text-white px-6 pt-1 h-screen pb-52 lg:h-[calc[100vh_-_100px]] overflow-y-auto" }
const _hoisted_2 = {
  key: 0,
  class: "custom-full"
}
const _hoisted_3 = {
  key: 1,
  class: "bg-[#2B2C32] rounded-lg px-[16px] max-w-full py-[16px]"
}
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "text-white px-4 pt-4" }
const _hoisted_6 = { class: "flex justify-between" }
const _hoisted_7 = {
  class: /*@__PURE__*/_normalizeClass('input-wrapper clearable bg-gray-black h-10 rounded-md mr-2 text-sm')
}
const _hoisted_8 = {
  class: /*@__PURE__*/_normalizeClass('input-wrapper clearable bg-gray-black h-10 rounded-md mr-2 text-sm')
}
const _hoisted_9 = { class: "flex flex-row" }
const _hoisted_10 = { class: "w-[114px] hover:opacity-70 rounded text-center flex justify-center items-center bg-white" }
const _hoisted_11 = {
  key: 2,
  class: /*@__PURE__*/_normalizeClass('w-full hidden-component z-10')
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_block_loading = _resolveComponent("block-loading")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_List = _resolveComponent("List")!
  const _component_restriction_alert = _resolveComponent("restriction-alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass('flex content-main gap-5 ' + (_ctx.action.component ? ' half-it' : ''))
      }, [
        (_ctx.can_view_or_manage_vault)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.loadingBadges)
                ? (_openBlock(), _createBlock(_component_block_loading, { key: 0 }))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                            type: "text",
                            class: "rounded w-full relative pl-9 h-[40px] bg-[#464851] align-top mr-4 border-0",
                            placeholder: "Search by Bank Deposit #, Transaction Type, or User"
                          }, null, 512), [
                            [_vModelText, _ctx.search]
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_Datepicker, {
                              inputFormat: 'yyyy-MM-dd',
                              clearable: true,
                              placeholder: "Start Date",
                              "upper-limit": _ctx.toDate,
                              modelValue: _ctx.fromDate,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fromDate) = $event)),
                              class: "focus:border-transparent focus:ring-0 bg-transparent w-[120px] border-0 h-10"
                            }, null, 8, ["upper-limit", "modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_Datepicker, {
                              inputFormat: 'yyyy-MM-dd',
                              clearable: true,
                              placeholder: "End Date",
                              "lower-limit": _ctx.fromDate,
                              modelValue: _ctx.toDate,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.toDate) = $event)),
                              class: "focus:border-transparent focus:ring-0 bg-transparent w-[120px] border-0 h-10"
                            }, null, 8, ["lower-limit", "modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("button", {
                                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.openModal('CloseVault')), ["prevent"])),
                                class: "font-normal text-base leading-5 text-[#2BA66B]"
                              }, "Close Vault")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode(_component_List, {
                      current: true,
                      selectedCallback: _ctx.selectedItem,
                      search: _ctx.search,
                      fromDate: _ctx.fromDate,
                      toDate: _ctx.toDate,
                      clearComponent: _ctx.clearComponent,
                      iscomponentactive: _ctx.action.component ? true : false
                    }, null, 8, ["selectedCallback", "search", "fromDate", "toDate", "clearComponent", "iscomponentactive"])
                  ]))
            ]))
          : (_openBlock(), _createBlock(_component_restriction_alert, { key: 1 })),
        (_ctx.action.component)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.action.component), {
                item: _ctx.action.data,
                clearComponent: _ctx.clearComponent
              }, null, 8, ["item", "clearComponent"]))
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createElementVNode("div", null, [
      (_ctx.cashModal.popup)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.cashModal.type), {
            key: 0,
            onClose: _ctx.closeCreate,
            totalBalance: _ctx.totalBalance
          }, null, 40, ["onClose", "totalBalance"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}